import React from "react";
import { HiXMark } from "react-icons/hi2";
import mahiDownloadLogo from "../../../assets/images/mahi-download-logo-512.png";

interface CancelPackOrderModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  cancelMessage?: string;
  onEditMessage?: () => void;
}

export default function CancelPackOrderModal({
  isOpen,
  onClose,
  onConfirm,
  cancelMessage = "",
  onEditMessage,
}: CancelPackOrderModalProps) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center p-4 z-50">
      <div className="bg-white p-6 rounded-lg shadow-xl w-full max-w-md">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-2xl font-bold text-gray-800">
            예약팩을 취소할까요?
          </h2>
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700"
          >
            <HiXMark className="w-6 h-6" />
          </button>
        </div>

        <p className="text-xl text-gray-600 mb-4">
          손님에게 아래와 같은 메시지가 발송됩니다.
        </p>

        {/* 알림톡 미리보기 */}
        <div className="bg-gray-100 px-2 py-4 rounded-lg mb-4">
          <div className="flex items-start space-x-3">
            {/* 프로필 이미지 */}
            <div className="w-10 h-10 bg-primary rounded-[1.1rem] flex items-center justify-center flex-shrink-0">
              <img src={mahiDownloadLogo} alt="" className="w-8 h-8" />
            </div>

            {/* 발신자 정보 */}
            <div className="flex-1">
              <div className="flex items-center space-x-2 mb-2">
                <span className="text-black font-semibold text-base">
                  마감히어로
                </span>
              </div>

              {/* 메시지 말풍선 */}
              <div className="bg-white text-black p-4 rounded-lg relative max-w-md shadow-sm">
                <div className="text-md">
                  <div className="text-gray-500 text-xs">취소 알림</div>
                  <div className="font-bold text-lg">주문 취소 안내</div>
                  <hr className="mt-1" />
                  <div className="text-base mt-2 whitespace-pre-wrap">
                    💬 [가게 메세지] <br />• 가게 메시지:{" "}
                    <span className="font-medium italic break-keep">
                      {cancelMessage ||
                        "저희 가게를 찾아주시고 기다려주셨을 텐데, 오늘은 준비한 재고가 모두 소진되어 부득이하게 예약을 취소드리게 되었어요. 소중한 주문 감사드려요."}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* 메시지 수정 링크 */}
        {onEditMessage && (
          <div
            onClick={onEditMessage}
            className="text-gray-500 text-md mb-4 break-keep underline underline-offset-2 cursor-pointer"
          >
            [문구 수정하기 (예약팩 취소 메시지 입력)]
          </div>
        )}

        {/* 버튼 */}
        <div className="flex justify-end gap-3">
          <button
            className="bg-gray-500 text-white px-4 py-2 rounded-lg hover:bg-gray-600 transition-colors"
            onClick={onClose}
          >
            취소
          </button>
          <button
            className="bg-blue-500 text-white px-4 py-2 rounded-lg hover:bg-blue-600 transition-colors"
            onClick={onConfirm}
          >
            확인
          </button>
        </div>
      </div>
    </div>
  );
}
